import React from 'react';
import { Badge } from 'react-bootstrap';
import { GrRefresh } from "react-icons/gr";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";

const SecurityHeader = ({
    onOpenLicense,
    onRefresh,
    onClearFilters,
    loading,
    hasCompletedPendingShifts
}) => {
    return (
        <>
            <button
                type="button"
                className="btn-security-action btn-security-action--clear"
                onClick={onClearFilters}
                disabled={loading}
            >
                Clear All
            </button>
            <button
                type="button"
                className="btn-security-action btn-security-action--license"
                onClick={onOpenLicense}
            >
                <HiOutlineClipboardDocumentList size={18} />
                Licence Conditions
            </button>
            <button
                type="button"
                className="btn-security-action btn-security-action--refresh position-relative"
                onClick={onRefresh}
                disabled={loading}
            >
                <GrRefresh className={loading ? 'spinning' : ''} size={16} />
                Refresh
                {hasCompletedPendingShifts && (
                    <Badge
                        bg="success"
                        className="position-absolute top-0 start-100 translate-middle rounded-circle"
                    >
                        !
                    </Badge>
                )}
            </button>
        </>
    );
};

export default SecurityHeader;
